import I18n from 'i18n-js';

import Markdown from '~/components/Markdown';

import { ReactComponent as ErrorIcon } from '~/assets/images/iconsLibrary/error.svg';

import styles from './NoDealsWidget.module.scss';

export function NoDealsWidget(): JSX.Element {
  return (
    <div className={styles.container}>
      <div className={styles.errorContainer}>
        <ErrorIcon className={styles.icon} />
      </div>
      <Markdown className={styles.errorText}>
        {I18n.t('deals_no_offer')}
      </Markdown>
    </div>
  );
}
